export default __webpack_public_path__ + "static/media/typebot.d8149c88.png";